<script setup>
import { onMounted, reactive, ref } from 'vue'
import MenuLayout from '../layout/MenuLayout.vue'
import { useMemberStore, useMetaStore } from '@/stores'
import { commaFormat, formatNumber, get, gets, hasIncompleteKor, loadEpsgs, loadEpsgsWithPrjInit, openWin, post, postMultipart, qsel, senitizeLonLatBbox, validators, ymd } from '@/common/util'
import { Feature, Map, Overlay, View } from 'ol'
import TileLayer from 'ol/layer/Tile'
import { ImageWMS, TileWMS } from 'ol/source'
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import ZoomSlider from 'ol/control/ZoomSlider'
import MousePosition from 'ol/control/MousePosition'
import ScaleLine from 'ol/control/ScaleLine.js';
import { createStringXY } from 'ol/coordinate'
import { defaults as defaultControls } from 'ol/control/defaults.js'
import { fromLonLat, toLonLat, transform, transformExtent, get as getProj } from 'ol/proj'
import { getArea, getDistance } from 'ol/sphere';
import LayerGroup from 'ol/layer/Group'
import config from '@/common/config'
import _ from 'lodash-es'
import MapControl from '@/common/MapControl'
import screenfull from 'screenfull'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON.js';
import Draw from 'ol/interaction/Draw'
import Snap from 'ol/interaction/Snap'
import { Circle, Fill, Icon, Stroke, Style } from 'ol/style'
import { LineString, Point } from 'ol/geom'
import WKT from 'ol/format/WKT'
import { Line } from 'vue-chartjs'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js'
import DataDetail from '@/components/member/DataDetail.vue'
import { boundingExtent, getTopLeft, getWidth } from 'ol/extent'
import Vue3TreeVue from 'vue3-tree-vue'
import 'vue3-tree-vue/dist/style.css'
import ImageLayer from 'ol/layer/Image'
import WMTSTileGrid from 'ol/tilegrid/WMTS'
import { register } from 'ol/proj/proj4'
import proj4 from 'proj4';
import BgMapSelector from '@/components/BgMapSelector.vue'
import Cookies from "js-cookie"
import { el } from 'vuetify/locale'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

const kext = ref({ minx: config.KoreaBbox.lonMin, miny: config.KoreaBbox.latMin, maxx: config.KoreaBbox.lonMax, maxy: config.KoreaBbox.latMax }), svtreeref = ref(null)
const metaStore = useMetaStore(), meta = reactive({
  showleft: false, tabs: ['layers', 'places_addr'], searchtabs: ['all', 'places', 'addr'], selsearchtab: 'all', ltreetypes: ['ods', 'layers']
  , seltab: 'layers', groups: [], selgroupid: 'defaultgroups', layers: [], layermodels: {}, layerseachcnt: 0, layerttlcnt: 0
  , sidos: [], sggs: [], umds: [], selsidocode: -1, selsggcode: -1, selumdcode: -1, suppressmoveend: false, poptype: null, selroutetype: 'car'
  , selmoveposepsg: 4326, movepos: { x: 0, y: 0 }, measureinters: {}, suppressmeasurefeatureadd: false, measureovers: [], selfeature: {}
  , selroute: { querysos: [], departsearched: [], stopoversearched: [], destsearched: [], querydepart: null, querydest: null }
  , extbasepattern: /((?:\d+\/)+)(\d+)(?:[^\/\.]+)?\.(png|jpg|jpeg|gif|webp|bmp)$/i
})
  , pop = (type, id) => {
    meta.poptype = null
    meta.popttl = null
    meta.routelayer.getSource().clear()
    if (type == 'metadata' || type == 'viewdatadetails') {
      meta.popttl = metaStore.t(type)
      meta.sellayer = ltreeitems(false).find(lyr => lyr.id == id)
      if (type == 'metadata') meta.popttl += ' : ' + meta.sellayer.nm
    }
    if (type == 'slope') {
      meta.popttl = metaStore.t('slope')
      tglMeasure()
    } else {
      meta.slopedata = null
      const slopefeatures = meta.measurelayer.getSource().getFeatures().filter(fea => fea.get('slopept') || fea.get('slopeline'))
      if (slopefeatures.length) meta.measurelayer.getSource().removeFeatures(slopefeatures)
    }
    if (type == 'memolist') {
      searchMemo()
      meta.popttl = metaStore.t('notelist')
    }
    setTimeout(() => {
      meta.poptype = type
      if (type == 'sv') {
        const itemwraps = svtreeref.value.$el.querySelectorAll('.tree-item')
        itemwraps.forEach(wrap => {
          const item = JSON.parse(wrap.querySelector('.itemval').value)
          const lbl = wrap.querySelector('label')
          lbl.setAttribute('id', item.id)
          lbl.setAttribute('isgroup', item.isgroup ? 'true' : 'false')
          lbl.onclick = evt => {
            const ci = findSvTreeItem(evt.target.id, evt.target.getAttribute('isgroup') === 'true')
            // if(ci.isgroup){
            //   const li=closest(evt.target,'li')
            //   const checked=!ci.checked
            //   li.querySelectorAll('.itemval').forEach(iv=>{
            //     iv=JSON.parse(iv.value)
            //     const ti=findSvTreeItem(iv.id,iv.isgroup)
            //     ti.checked=checked
            //   })
            // }else{
            //   ci.checked=!ci.checked
            //   focusLayer(ci.gspointnm)
            // }
            // checkSvTree()
            if (!ci.isgroup) focusLayer(ci.gspointnm)
          }
          lbl.previousElementSibling.onclick = evt => evt.target.parentElement.nextElementSibling.click()
        })
      }
    }, 100);
  }, saveMemo = async () => {
    metaStore.blockLoading()
    const res = await postMultipart('rest/authed/member/savememo', meta.selmemo)
    metaStore.blockLoading(false)
    metaStore.toastRslt(res, true)
    memoDetailPop()
    searchMemo()
  }, delMemo = async (id) => {
    metaStore.blockLoading()
    const res = await post('rest/authed/member/delmemo', { id: id })
    metaStore.blockLoading(false)
    metaStore.toastRslt(res, false)
    searchMemo(1)
  }, memoImgChanged = async () => {
    const img = qsel('.memoimg')
    if (meta.selmemo.file) {
      img.src = window.URL.createObjectURL(meta.selmemo.file)
      img.classList.remove('d-none')
    } else img.classList.remove('d-none')
  }, memoDetailPop = async (id) => {
    meta.selmemo = null
    metaStore.pop({
      ison: id != null, callback: async () => {
        if (!id) return
        meta.selmemo = { ...meta.memos.find(memo => memo.id == id) }
        if (!meta.selmemo) return
        const files = await post(`rest/authed/member/attachedfiles`, { tartbl: 'Memo', refids: [id] })
        const img = qsel('.memoimg')
        if (files.data.length) {
          img.src = config.backend + 'attachedfile/' + files.data[0].id
          img.classList.remove('d-none')
        } else img.classList.remove('d-none')
      }
    })
  }, searchMemo = async (page = 1) => {
    const pm = { where: { ttl_or_: meta.memosearchval }, page: page, size: 5, sortcol: 'mdt', isasc: false }
    pm.where.cont_or_ = pm.where.ttl_or_
    const res = await post('rest/authed/member/searchmemo', pm)
    meta.memos = res.data.rows
  }, vwapi = async (method = 'get', data, callback = () => { }) => {
    const url = 'rest/authed/member/vwapi'
    if (data instanceof Function) {
      callback = data
      data = null
    }
    if (method == 'get') return await get(url, callback, data)
    return await post(url, data, callback)
  }, searchAddrOrPlace = async (query, type, category, page = 1, size = 10, needblock = false, crs, bbox) => {
    // type PLACE : 장소 ADDRESS : 주소 DISTRICT : 행정구역 ROAD : 도로명
    //category 주소 : ROAD(도로), PARCEL(지번) 행정구역 : L1(시도), L2(시군구), L3(일반구), L4(읍면동)
    const data = {
      path: 'req/search', service: 'search', request: 'search', version: '2.0', format: 'json', errorformat: 'json'
      , key: meta.vwapikey, category: category, size: size, page: page, query: query, type: type
    }
    if (bbox) data.bbox = bbox
    if (crs) data.crs = crs
    else data.crs = meta.map.getView().getProjection().getCode()
    if (needblock) metaStore.blockLoading()
    const res = await vwapi('get', data)
    if (needblock) metaStore.blockLoading(false)
    if (res.response.status == 'ERROR') metaStore.toast('브이월드 에러:' + res.response.error.text, false)
    return res
  }, debounceSearchAddrOrPlace = _.debounce(searchAddrOrPlace, 200)
  , routePtSearch = async (type, idx) => {
    let query = meta.selroute.querydepart
    if (type == 'stopover') query = meta.selroute.querysos[idx]
    if (type == 'destination') query = meta.selroute.querydest
    if (!_.isString(query)) meta.selroute.ready = meta.selroute.querydepart?.id && meta.selroute.querydest?.id
    if (!_.isString(query) || _.isEmpty(query) || query.length < 2 || hasIncompleteKor(query)) return
    const tararr = []
    const addrs = await searchAddrOrPlace(query, 'ADDRESS', 'ROAD', 1, 5)
    const places = await searchAddrOrPlace(query, 'PLACE', '', 1, 5)
    const rslts = { addrs: addrs.response.result?.items, places: places.response.result?.items }
    _.entries(rslts).forEach(([key, val]) => {
      if (!val) return
      val.forEach(searched => {
        if (tararr.find(it => it.id == searched.id)) return
        let ttl = ''
        if (searched.ttl) ttl = `${searched.ttl}:`
        ttl += `${searched.address.road}[${searched.address.parcel}]`
        tararr.push({ ttl: ttl, id: searched.id, pt: searched.point })
      })
    })
    if (type == 'departure') meta.selroute.departsearched = tararr
    if (type == 'stopover') meta.selroute.stopoversearched[idx] = tararr
    if (type == 'destination') meta.selroute.destsearched = tararr
  }, debounceRoutePtSearch = _.debounce(routePtSearch, 300)
  , actRoute = async () => {
    if (!meta.selroute.ready) return
    let pts = [[meta.selroute.querydepart.pt.x, meta.selroute.querydepart.pt.y]]
    meta.selroute.querysos.filter(so => so.pt).forEach(so => pts.push([so.pt.x, so.pt.y]))
    pts.push([meta.selroute.querydest.pt.x, meta.selroute.querydest.pt.y])
    pts = pts.map(pt => toLonLat(pt, meta.map.getView().getProjection()))
    metaStore.blockLoading()
    const res = await post('rest/authed/member/route', { pts: pts, kind: meta.selroutetype, instructions: true, maxPaths: 2 })
    metaStore.blockLoading(false)
    res.data.dists = []
    res.data.paths.forEach((path, idx) => {
      res.data.dists[idx] = 0
      path.instructions.forEach(ins => res.data.dists[idx] += ins.distance)
    })
    meta.selroute.rslt = res.data
  }, drawRoute = async () => {
    meta.routelayer.getSource().clear()
    if (meta.selroute.rslt.selidx == null) return
    const path = meta.selroute.rslt.paths[meta.selroute.rslt.selidx]
    const line = new Feature({ geometry: new LineString((path.points.coordinates)) })
    line.getGeometry().transform('EPSG:4326', meta.map.getView().getProjection())
    line.setStyle(new Style({ stroke: new Stroke({ color: '#800080', width: 4 }) }))
    meta.routelayer.getSource().addFeature(line)
    fitToExtent(line.getGeometry().getExtent())
  }, posToAddr = async (coord) => {
    const pms = {
      path: 'req/address', service: 'address', request: 'getAddress', version: '2.0', crs: 'EPSG:3857', type: 'both', zipcode: 'true', simple: 'false',
      key: meta.vwapikey, point: coord
    }
    return await vwapi('get', pms)
  }, addrToPos = async (addr, type = 'ROAD') => {
    //PARCEL : 지번주소 ROAD : 도로명주소
    const pms = {
      path: 'req/address', service: 'address', request: 'getcoord', version: '2.0', refine: false, crs: 'EPSG:3857', simple: true
      , type: type, address: addr, key: meta.vwapikey
    }
    return await vwapi('get', pms)
  }, selProvince = (type, admcode, callback) => {
    meta[`sel${type.substring(0, type.length - 1)}code`] = admcode
    if (admcode == -1) return
    if (type == 'sidos') {
      korProvinces('sggs', admcode, callback)
      meta.selsggcode = -1
    }
    if (type == 'sggs') {
      korProvinces('umds', admcode, callback)
      meta.selumdcode = -1
    }
    const addr = meta[type].find(prov => prov.admCode == admcode).admCodeNm
    if (callback) return
    addrToPos(addr).then(res => {
      let pt = res.response.result.point
      pt = [parseFloat(pt.x), parseFloat(pt.y)]
      meta.suppressmoveend = true
      meta.map.getView().setCenter(pt)
      setTimeout(() => meta.suppressmoveend = false, 100);
    })
  }, debounceSelProvince = _.debounce(selProvince, 100)
  , korProvinces = (type, admcode, callback) => {
    let pms = { path: 'ned/data/admCodeList', key: meta.vwapikey, numOfRows: 1000, domain: meta.vwdomain }
    if (type == 'sggs') pms.path = 'ned/data/admSiList'
    if (type == 'umds') pms.path = 'ned/data/admDongList'
    if (admcode) pms.admCode = admcode
    vwapi('get', pms, res => {
      if (!res.admVOList.admVOList) return
      const list = res.admVOList.admVOList
      list.unshift(meta[type][0])
      if (JSON.stringify(meta[type]) !== JSON.stringify(list)) meta[type] = list
      if (callback) callback()
    })
  }, selSearched = async (id) => {
    let searchedOverlay = meta.map.getOverlayById('searched_pop')
    if (!searchedOverlay) {
      searchedOverlay = new Overlay({ id: 'searched_pop', positioning: 'top-left', offset: [0, -12], element: qsel('.mapdetailpop') })
      searchedOverlay.getElement().querySelector('.mapdetailpop_close').onclick = () => selSearched()
      meta.map.addOverlay(searchedOverlay)
    }
    meta.searched.pop = searchedOverlay
    meta.searchlayer.getSource().getFeatures().filter(fea => fea.get('selected')).forEach(fea => fea.set('selected', null))
    if (!id) {
      meta.searched.sel = null
      meta.searched.pop.setPosition(null)
      return
    }
    const feature = meta.searchlayer.getSource().getFeatures().find(fea => fea.get('id') == id)
    meta.searchlayer.getSource().removeFeature(feature)
    meta.searchlayer.getSource().addFeature(feature)
    feature.set('selected', true)
    const pos = feature.getGeometry().getCoordinates()
    meta.searched.sel = meta.searched.addrs.items.concat(meta.searched.places.items).find(item => item.id == id)
    const cont = meta.searched.pop.getElement().querySelector('.popcont')
    cont.innerHTML = ''
    if (meta.searched.sel.title) cont.innerHTML += `<h3>${meta.searched.sel.title}</h3>`
    cont.innerHTML += `<p class="mb-1">${meta.searched.sel.address.road}</p>`
    if (meta.searched.sel.address.parcel) cont.innerHTML += `<p>${meta.searched.sel.address.parcel}</p>`
    const lonlat = toLonLat(pos, meta.map.getView().getProjection())
    cont.innerHTML += `<p class="mt-1 font-weight-bold">${metaStore.t('coordinates')}:${lonlat[0].toFixed(4)},${lonlat[1].toFixed(4)}</p>`
    meta.searched.pop.setPosition(pos)
    meta.map.getView().animate({ center: pos, duration: 200 })
  }, search = async (page, isclear) => {
    if (isclear) meta.searchval = null
    meta.searched = { places: { items: [] }, addrs: { items: [] } }
    selSearched()
    meta.searchlayer.getSource().clear()
    if (!_.isEmpty(meta.searchval)) {
      metaStore.blockLoading()
      if (meta.selsearchtab == 'all' || meta.selsearchtab == 'places') {
        const sizeperpage = meta.selsearchtab == 'all' ? 3 : 10
        const places = await searchAddrOrPlace(meta.searchval, 'PLACE', '', page, sizeperpage)
        if (places.response.result) {
          meta.searched.places.items = places.response.result.items
          meta.searched.places.ttl = parseInt(places.response.record.total)
          meta.searched.places.dpcnt = parseInt(places.response.record.current)
          meta.searched.places.pagettl = parseInt(places.response.page.total) - 1
          meta.searched.places.currpage = parseInt(places.response.page.current)
          meta.searched.places.pagesize = parseInt(places.response.page.size)
        }
      }
      if (meta.selsearchtab == 'all' || meta.selsearchtab == 'addr') {
        const sizeperpage = meta.selsearchtab == 'all' ? 3 : 10
        const addrs = await searchAddrOrPlace(meta.searchval, 'ADDRESS', 'ROAD', page, sizeperpage)
        if (addrs.response.result) {
          meta.searched.addrs.items = addrs.response.result.items
          meta.searched.addrs.ttl = parseInt(addrs.response.record.total)
          meta.searched.addrs.dpcnt = parseInt(addrs.response.record.current)
          meta.searched.addrs.pagettl = parseInt(addrs.response.page.total) - 1
          meta.searched.addrs.currpage = parseInt(addrs.response.page.current)
          meta.searched.addrs.pagesize = parseInt(addrs.response.page.size)
        }
      }
      metaStore.blockLoading(false)
      const pts = []
      meta.searched.addrs.items.concat(meta.searched.places.items).forEach(item => {
        const pt = [parseFloat(item.point.x), parseFloat(item.point.y)]
        pts.push(pt)
        const fea = new Feature({ geometry: new Point(pt), id: item.id })
        meta.searchlayer.getSource().addFeature(fea)
      })
      meta.searched.ttl = pts.length
      if (pts.length) fitToExtent(boundingExtent(pts))
    } else {
      meta.searched.ttl = 0
    }
  }, ltreeitems = (notorig = true) => {
    return meta.ltreetypes.flatMap(t => meta[t][notorig ? 'layers' : 'olayers'].map(l => ({ ...l, ltreetype: t })))
  }, pickServerFeatures = async (pos) => {
    meta.onrequest = true
    const proj = meta.map.getView().getProjection()
    const resolution = meta.map.getView().getResolution()
    const olyrs = ltreeitems().filter(l => l.shown && (l.ltreetype === 'ods' || (l.ltreetype === 'layers' && l.layerkind === 'vector')))
      .map(lyr => ({ name: lyr.gslayernm, id: lyr.id, layertype: lyr.layertype }))
    meta.svtree.flatMap(group => group.children).filter(sv => sv.checked).forEach(sv => {
      olyrs.push({ id: sv.id, name: sv.gspointnm, layertype: sv.layertype })
      if (sv.layertype != 'Point') olyrs.push({ id: sv.id, name: sv.gslinenm, layertype: sv.layertype })
    })
    const lyrs = []
    olyrs.forEach(lyr => {
      if (meta.gslyrnms.includes(lyr.name)) lyrs.push(lyr)
      else console.log('not exist on gs', lyr)
    })
    const wsource = meta.map.getAllLayers().map(lyr => lyr.getSource()).find(so => so.getFeatureInfoUrl != null)
    if (!lyrs.length || !wsource) {
      metaStore.toast('조회 가능한 레이어가 없습니다.', false)
      return null;
    }
    const lyrnms = lyrs.map(lyr => lyr.name).toString()
    const url = wsource.getFeatureInfoUrl(pos, resolution, proj, { INFO_FORMAT: 'application/json' })
    const queryString = url.split('?')[1]
    const searchParams = new URLSearchParams(queryString)
    searchParams.delete('STYLES')
    searchParams.delete('QUERY_LAYERS')
    searchParams.delete('LAYERS')
    searchParams.append('FEATURE_COUNT', lyrs.length * 2)
    searchParams.append('BUFFER', 30)
    searchParams.append('QUERY_LAYERS', lyrnms)
    searchParams.append('LAYERS', lyrnms)
    let res
    try {
      res = await fetch(config.backend + 'wms', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: searchParams.toString()
      });
      res = await res.json();
    } catch (e) {
      metaStore.toast('레이어/거리뷰 요청 에러.', false)
    }
    meta.onrequest = false
    return res?.features
  }, filterLayer = (type, isclear) => {
    if (isclear) meta.searchval = null
    if (!meta.searchval) return meta.layers.layers = meta.layers.olayers
    meta.layers.layers = meta.layers.olayers.filter(lyr => lyr.nm.includes(meta.searchval))
  }, getLayergroup = grouptype => {
    let group
    if (grouptype == 'base') group = meta.basemapgroup
    if (grouptype == 'layer' || grouptype == 'layers') group = meta.layergroup
    if (grouptype == 'od' || grouptype == 'ods') group = meta.odgroup
    if (grouptype == 'sv') group = meta.svgroup
    return group
  }, opaqueLayer = (grouptype, id, per) => {
    let group = getLayergroup(grouptype)
    if (per == 0) per = 1
    group.getLayers().getArray().find(lyr => lyr.get('id') == id).setOpacity(per / 100)
  }, wmsLayerSource = (url, params, isvectile = false) => {
    const wmtslyr = meta.wmtscapa.Contents.Layer.find(layer => layer.Title === params.LAYERS)
    const layerkind = params.layerkind
    delete params.layerkind
    if (wmtslyr && layerkind == 'raster') {
      let extent = [wmtslyr.WGS84BoundingBox[0], wmtslyr.WGS84BoundingBox[1],
      wmtslyr.WGS84BoundingBox[2], wmtslyr.WGS84BoundingBox[3]]
      extent = transformExtent(extent, 'EPSG:4326', 'EPSG:900913')
      const options = optionsFromCapabilities(meta.wmtscapa, {
        layer: wmtslyr.Identifier,
        matrixSet: 'EPSG:900913',
        extent: extent
      })
      if (options) {
        options.urls = [config.backend + 'wmts?']
        return new WMTS(options)
      }
    }
    if (isvectile) return new TileWMS({
      url: url,
      params: {
        ...params,
        TILED: true,
      },
      projection: meta.wmtsproj,
      tileGrid: new WMTSTileGrid({
        origin: getTopLeft(meta.wmtsproj.getExtent()),
        resolutions: meta.wmtsresolutions,
        matrixIds: meta.wmtsmatrixids,
      }),
      serverType: 'geoserver',
      transition: 0,
      ratio: 1
    })
    return new ImageWMS({ url: url, params: { ...params/*,TILED: true*/ }, serverType: 'geoserver', transition: 0, ratio: 1 })
  }, tglLayer = (grouptype, id, flag) => {
    const group = getLayergroup(grouptype)
    const lyrs = group.getLayers().getArray()
    if (id == 'all') {
      lyrs.forEach(lyr => {
        const shown = id == 'all' || lyr.get('id') == id ? flag : !flag
        meta[grouptype].layers.find(l => l.id == lyr.get('id')).shown = shown
        lyr.setVisible(shown)
      })
    } else {
      const lyr = lyrs.find(lyr => lyr.get('id') == id)
      if (lyr) {
        meta[grouptype].layers.find(l => l.id == lyr.get('id')).shown = flag
        lyr.setVisible(flag)
      }
    }
  }, addLayer = (grouptype, obj, hidden = false) => {
    let group, layer, url, params
    if (grouptype == 'layer' || grouptype == 'layers') {
      group = meta.layergroup
      if (obj.layerkind == 'api') {
        url = new URL(obj.apiurl)
        url.search = ''
        url = url.toString()
        const queries = new URLSearchParams(new URL(obj.apiurl).search)
        params = {}
        queries.forEach((value, key) => params[key] = value)
      } else {
        if (!obj.gslayernm) return
        params = { LAYERS: obj.gslayernm, layerkind: obj.layerkind }
        if (!_.isEmpty(obj.style)) params.STYLES = obj.style
        url = config.backend + 'wms'
        if (obj.layerkind == 'raster') {
          layer = new TileLayer({ source: wmsLayerSource(url, params) })
        }
      }
    } else if (grouptype == 'od' || grouptype == 'ods') {
      group = meta.odgroup
      if (!obj.gslayernm) return
      params = { LAYERS: obj.gslayernm, layerkind: 'vector' }
      if (!_.isEmpty(obj.style)) params.STYLES = obj.style
      url = config.backend + 'wms'
    } else if (grouptype == 'sv') {
      group = meta.svgroup
      url = config.backend + 'wms'
      params = { LAYERS: obj.gspointnm + ',' + obj.gslinenm }
      if (!_.isEmpty(obj.style)) params.STYLES = obj.style
    }
    // if(!layer)layer=new TileLayer({source:wmsLayerSource(url,params,true)})
    if (!layer) {
      layer = new ImageLayer({ source: wmsLayerSource(url, params) })
      if (!_.isEmpty(obj.style)) {
        layer.getSource().setImageLoadFunction((image, src) => {
          const resolution = meta.map.getView().getResolution();
          const meterRadius = 30 * resolution;
          image.getImage().src = src + `&env=layer:${obj.gsworkspace}:${obj.gslayernm};meter:${meterRadius}`;
        });
      }
    }
    if (!layer) return null
    layer.set('group', group)
    layer.set('id', obj.id)
    layer.set('nm', obj.nm)
    layer.setVisible(!hidden)
    if (layer instanceof ImageLayer) {
      layer.getSource().on('imageloaderror', function (event) {
        const lnm = event.target.getParams().LAYERS
        let type = 'layers'
        if (lnm.includes('od_')) type = 'ods'
        else if (lnm.includes('sv_')) type = 'svs'
        const id = _.last(lnm.split('_'))
        let typelbl = '', nm = ''
        if (type == 'svs') {
          const sv = findSvTreeItem(id)
          typelbl = '거리뷰'
          nm = sv.nm
        } else {
          const lyr = meta[type].layers.find(l => l.id == id)
          typelbl = type == 'layers' ? '레이어' : '객체탐지'
          nm = lyr.nm
        }
        metaStore.toast(`${typelbl} [${nm}]의 데이터/스타일을 확인해 주세요`, false)
      })
    }
    group.getLayers().push(layer)
    return layer
  }, setCen = (epsg, pos) => {
    try {
      pos = transform(pos, 'EPSG:' + epsg, meta.map.getView().getProjection())
      if (isNaN(pos[0]) || isNaN(pos[1])) {
        alert('올바르지 않은 좌표입니다.')
        return
      }
      meta.map.getView().animate({ zoom: 16, center: pos })
    } catch (e) {
      alert('올바르지 않은 좌표입니다.')
    }
  }, slopeHover = (evt, chartel) => {
    if (!chartel.length) return
    const lastspt = meta.measurelayer.getSource().getFeatures().find(fea => fea.get('slopept'))
    if (lastspt) meta.measurelayer.getSource().removeFeature(lastspt)
    chartel = chartel[0]
    const slope = meta.slopedata.slopes[chartel.index]
    const pos = [slope.x, slope.y]
    setCen(4326, pos)
    const pt = new Feature({ geometry: new Point(fromLonLat(pos, meta.map.getView().getProjection())) })
    pt.set('slopept', true)
    meta.suppressmeasurefeatureadd = true
    meta.measurelayer.getSource().addFeature(pt)
    setTimeout(() => meta.suppressmeasurefeatureadd = false, 100)
  }, marea = (featureorgeom, islonlat) => {
    if (featureorgeom.getGeometry) featureorgeom = featureorgeom.getGeometry()
    return getArea(featureorgeom, { projection: meta.map.getView().getProjection() })
  }, formArea = (areaInSquareMeters) => {
    if (areaInSquareMeters == null || isNaN(areaInSquareMeters)) return '-';
    const abs = Math.abs(areaInSquareMeters);
    if (abs >= 1_000_000) {
      return formatNumber(areaInSquareMeters / 1_000_000) + ' km²';
    } else if (abs >= 1) {
      return formatNumber(areaInSquareMeters) + ' m²';
    } else {
      return formatNumber(areaInSquareMeters * 10_000, 1) + ' cm²';
    }
  }, formDist = (meters) => {
    if (meters == null || isNaN(meters)) return '-';
    const abs = Math.abs(meters);
    if (abs >= 1000) {
      return formatNumber(meters / 1000) + ' km';
    } else if (abs >= 1) {
      return formatNumber(meters) + ' m';
    } else {
      return formatNumber(meters * 100, 1) + ' cm';
    }
  }, mdist = (frompos, topos, islonlat) => {
    if (!islonlat) {
      frompos = toLonLat(frompos)
      topos = toLonLat(topos)
    }
    return getDistance(frompos, topos)
  }, clearMeasure = () => {
    tglMeasure()
    meta.measurelayer.getSource().clear()
    meta.measureovers.forEach(ol => meta.map.removeOverlay(ol))
    meta.measureovers = []
    meta.slopedata = null
  }, tglMeasure = (type) => {
    _.keys(meta.measureinters).forEach(key => meta.map.removeInteraction(meta.measureinters[key]))
    meta.measuretype = type
    if (!type) return
    let geomtype = 'LineString'
    if (type == 'area') geomtype = 'Polygon'
    if (type == 'radius') geomtype = 'Circle'
    const source = meta.measurelayer.getSource()
    meta.measureinters.draw = new Draw({ source: source, type: geomtype })
    meta.measureinters.snap = new Snap({ source: source })
    //meta.measureinters.mod=new Modify({source:source})
    _.keys(meta.measureinters).forEach(key => meta.map.addInteraction(meta.measureinters[key]))
  }, mapPopRows = (cellsContent, isHeader = false, colspan = 1, bottomline = false) => {
    const row = document.createElement('tr')
    cellsContent.forEach(content => {
      const cell = document.createElement(isHeader ? 'th' : 'td')
      cell.textContent = content
      cell.colSpan = colspan
      if (isHeader) {
        cell.style.textAlign = 'center'
        cell.style.fontWeight = 'bold'
      }
      if (bottomline) cell.style.borderBottom = '1px solid grey'
      row.appendChild(cell)
    })
    return row
  }, mapPosEl = (feature) => {
    const geometry = feature.getGeometry()
    const type = geometry.getType()
    const coords = geometry.getCoordinates()
    let coordGroups = []

    if (type === 'Point') coordGroups = [[coords]];
    else if (type === 'MultiPoint' || type === 'LineString') coordGroups = [coords]
    else if (type === 'Polygon' || type === 'MultiLineString') coordGroups = coords
    else if (type === 'MultiPolygon') coordGroups = coords.flat()
    else coordGroups = []

    const wrapperDiv = document.createElement('div')
    wrapperDiv.classList.add('v-alert', 'v-theme--light', 'v-alert--density-compact', 'v-alert--variant-outlined', 'ma-1')
    wrapperDiv.setAttribute('role', 'alert')

    const contentDiv = document.createElement('div')
    contentDiv.classList.add('v-alert__content')
    wrapperDiv.appendChild(contentDiv)

    const table = document.createElement('table')
    table.classList.add('w-100')
    const tbody = document.createElement('tbody')
    table.appendChild(tbody)
    contentDiv.appendChild(table)

    coordGroups.forEach((group, groupIndex) => {
      tbody.appendChild(mapPopRows([`Item ${groupIndex + 1}`], true, 3, true))
      tbody.appendChild(mapPopRows(['X좌표', '', 'Y좌표'], true))

      group.forEach(coord => {
        const row = mapPopRows([coord[0].toFixed(5), '|', coord[1].toFixed(5)])
        row.querySelectorAll('td').forEach(cell => cell.classList.add('text-center'))
        tbody.appendChild(row)
      })
    })
    if (type === 'MultiPoint' || type === 'MultiLineString' || type === 'MultiPolygon') {
      let multiFeatureWrapper = document.createElement('div')
      coordGroups.forEach((group, groupIndex) => {
        const multiFeatureDiv = document.createElement('div')
        multiFeatureDiv.classList.add('v-alert', 'v-theme--light', 'v-alert--density-compact', 'v-alert--variant-outlined', 'ma-1')
        multiFeatureDiv.setAttribute('role', 'alert')

        const multiFeatureContentDiv = document.createElement('div')
        multiFeatureContentDiv.classList.add('v-alert__content')
        multiFeatureDiv.appendChild(multiFeatureContentDiv)

        const multiFeatureTable = document.createElement('table')
        multiFeatureTable.classList.add('w-100')
        const multiFeatureTbody = document.createElement('tbody')
        multiFeatureTable.appendChild(multiFeatureTbody)
        multiFeatureContentDiv.appendChild(multiFeatureTable)

        multiFeatureTbody.appendChild(mapPopRows([`Item ${groupIndex + 1}`], true, 3, true))
        multiFeatureTbody.appendChild(mapPopRows([metaStore.t('xcoordinate'), '', metaStore.t('ycoordinate')], true))

        group.forEach(coord => {
          const row = mapPopRows([coord[0].toFixed(5), '|', coord[1].toFixed(5)])
          row.querySelectorAll('td').forEach(cell => cell.classList.add('text-center'))
          multiFeatureTbody.appendChild(row)
        })

        multiFeatureWrapper.appendChild(multiFeatureDiv)
      })
      return multiFeatureWrapper
    }
    return wrapperDiv
  }, popFeatureInfo = async (featuredata, clickpos) => {
    let selfeatureOverlay = meta.map.getOverlayById('selfeature_pop')
    if (!selfeatureOverlay) {
      selfeatureOverlay = new Overlay({ id: 'selfeature_pop', positioning: 'top-left', offset: [0, 0], element: qsel('.mapdetailpop') })
      selfeatureOverlay.getElement().querySelector('.mapdetailpop_close').onclick = () => popFeatureInfo()
      meta.map.addOverlay(selfeatureOverlay)
    }
    meta.selfeature.pop = selfeatureOverlay
    meta.selfeature.pop.setPosition(null)
    meta.picklayer.getSource().clear()
    meta.selfeature.data = featuredata
    delete meta.selfeature.layer_detail_url
    delete meta.selfeature.layer_svlink_url
    if (!featuredata || !clickpos) return
    if (featuredata && featuredata.id) {
      let res = await get('rest/authed/member/featurelink/layer_detail/' + featuredata.id)
      if (res.data.id && res.data.url) meta.selfeature.layer_detail_url = res.data.url
      res = await get('rest/authed/member/featurelink/layer_svlink/' + featuredata.id)
      if (res.data.id && res.data.url) meta.selfeature.layer_svlink_url = res.data.url
    }
    if (!featuredata) return
    const layerinfo = ltreeitems().find(lyr => lyr.gslayernm == meta.selfeature.data.id.split('.')[0])
    meta.popinfokind = metaStore.t(layerinfo.ltreetype == 'ods' ? 'objectdetection' : 'layers')
    const cont = meta.selfeature.pop.getElement().querySelector('.popcont')
    let conthtml = '<div class="maplayerdetailcont" style="max-height:70vh;min-width:350px;overflow-y:auto;">'
    conthtml += `<h4>${metaStore.t('uniquenumber')}:${featuredata.id}</h4>`
    conthtml += `<p>${metaStore.t('coordinatesystem')}:${'EPSG:' + layerinfo.epsg}</p>`
    if (meta.selfeature.layer_detail_url || meta.selfeature.layer_svlink_url) {
      let buttondiv = '<div style="display: flex; width: 100%;margin-top:10px;margin-bottom:10px;">'
      if (meta.selfeature.layer_detail_url) buttondiv += `<a href="${meta.selfeature.layer_detail_url}" target="_blank" style="background-color: #008CBA;color: white;display: inline-block;padding: 5px 32px;cursor:pointer;margin:auto;text-decoration: none;">상세 보기</a>`
      if (meta.selfeature.layer_svlink_url) buttondiv += `<a href="${meta.selfeature.layer_svlink_url}" target="_blank" style="background-color: #008CBA;color: white;display: inline-block;padding: 5px 32px;cursor:pointer;margin:auto;text-decoration: none;">근처 거리뷰 보기</a>`
      buttondiv += '</div>'
      conthtml += buttondiv
    }
    const props = meta.selfeature.data.properties
    let ocr_list = props.ocr_list
    delete props.ocr_list
    const featureimgs = _.entries(props).filter(([key, val]) => val && val.toString().toLowerCase().startsWith('img:'))
    featureimgs.forEach(([key, val]) => {
      if (!val) val = '';
      val = val.toString().trim().replace('img:', '')
      conthtml += `<img src="${val}" style="max-width:350px;cursor:pointer;" onclick="window.open('${val}')"/>`
    })
    if (layerinfo.ltreetype == 'ods') {
      try {
        ocr_list = props.ocr
      } catch (e) {
        ocr_list = '[]'
      }
      const src = `${config.backend}rest/public/objdetect/thumbnail/${props.refid}/${props.featureid}`
      conthtml += `<img src="${src}" style="max-width:350px;cursor:pointer;" onclick="window.open('${src}')" onerror="this.style.display='none'"/>`
      featureimgs.push(['thumbnail', props.thumbnail])
    }
    const imgKeySet = new Set(featureimgs.map(([key]) => key))
    const featureprops = _.entries(props).filter(([key]) => !imgKeySet.has(key))
    featureprops.forEach(([key, val]) => {
      if (!val) val = '';
      val = val.toString().trim();
      if (layerinfo.ltreetype == 'ods') {
        if (['memo', 'refid', 'featureid', 'ocr'].includes(key)) return
        key = metaStore.t(key)
      }
      if (val.startsWith('http://') || val.startsWith('https://')) conthtml += `<p>${key}:<a href="${val}" target="_blank">${val}</a></p>`
      else conthtml += `<p>${key}:${val}</p>`
    })
    conthtml += '<hr style="margin-top:20px;"/>'
    if (ocr_list && ocr_list.length) {
      ocr_list = ocr_list.split(',').filter(ocr => ocr.trim()).map(ocr => ocr.replaceAll("'", '').replaceAll('"', ''))
      if (ocr_list.length) {
        conthtml += '<h3 style="margin-top:10px;margin-bottom:10px;">OCR</h3>'
        conthtml += '<div class="v-alert v-theme--light v-alert--density-compact v-alert--variant-outlined ma-1" role="alert"><div class="v-alert__content">'
        ocr_list.forEach(otxt => {
          conthtml += `<p>${otxt}</p>`
        })
        conthtml += '</div></div>'
      }
    }
    conthtml += '<h3 style="margin-top:10px;margin-bottom:10px;">' + metaStore.t('coordinateinformation') + '</h3>'
    conthtml += '</div>'
    cont.innerHTML = conthtml
    const feature = new GeoJSON().readFeature(meta.selfeature.data, { dataProjection: meta.map.getView().getProjection(), featureProjection: 'EPSG:' + layerinfo.epsg })
    meta.selfeature.pop.getElement().querySelector('.maplayerdetailcont').appendChild(mapPosEl(feature))
    const closestPoint = feature.getGeometry().transform('EPSG:' + layerinfo.epsg, meta.map.getView().getProjection()).getClosestPoint(clickpos)
    meta.map.getView().animate({ zoom: meta.map.getView().getZoom(), center: closestPoint, duration: 300 })
    setTimeout(() => meta.selfeature.pop.setPosition(closestPoint), 400)
  }, focusLayer = (layernm) => {
    if (meta.bboxes && meta.bboxes[layernm]) {
      meta.map.updateSize()
      meta.map.getView().fit(meta.bboxes[layernm], {
        padding: [200, 200, 200, 200], size: meta.map.getSize(), duration: 300, callback: () => {
          if (meta.map.getView().getZoom() > 19) meta.map.getView().setZoom(19)
        }
      })
    } else {
      metaStore.toast('해당 레이어의 영역정보가 없습니다.', false)
    }
  }, findSvTreeItem = (id, isgroup) => {
    let item
    if (isgroup) item = meta.svtree.find(group => group.id == id)
    else item = meta.svtree.flatMap(group => group.children).find(sv => sv.id == id)
    return item
  }, selSvFeature = async (svfeature) => {
    const svid = svfeature.id.split('_')[2].split('.')[0];
    openWin(config.frontRoot + 'member/svnew/' + svid + '/' + svfeature.properties.featureid + '/' + meta.selbgmapid)
  }, checkSvTree = async () => {
    const checkeds = meta.svtree.flatMap(group => group.children).filter(item => item.checked)
    meta.svgroup.getLayers().forEach(lyr => lyr.setVisible(checkeds.map(item => item.id).includes(lyr.get('id'))))
  }, initSvs = async () => {
    let res = await post('rest/authed/member/svsandgroups')
    const svtree = [{ name: metaStore.t('defaultgroups'), id: 'defaultgroups', children: [], expanded: true, isgroup: true }]
    _.sortBy(res.data.groups, 'gorder').forEach(group => svtree.push({ ...group, name: group.nm, children: [], expanded: true, isgroup: true }))
    res.data.svs = _.sortBy(res.data.svs, 'order')
    res.data.svs = res.data.svs.filter(sv => sv.enabled && sv.processstatus == 'complete')
    svtree.forEach(group => res.data.svs.filter(sv => sv.groupid == (group.id == 'defaultgroups' ? null : group.id)).forEach(sv => {
      const svtreeitem = { ...sv, name: sv.nm, checked: true }
      group.children.push(svtreeitem)
      addLayer('sv', sv, !svtreeitem.checked)
    }))
    meta.svtree = svtree
  }, fitToExtent = (extent) => {
    meta.map.getView().fit(extent, {
      padding: [200, 200, 200, 200], size: meta.map.getSize(), duration: 300, callback: () => {
        if (meta.map.getView().getZoom() > 19) meta.map.getView().setZoom(19)
      }
    })
  }, initMap = () => {
    meta.wmtsproj = getProj('EPSG:900913')
    const size = getWidth(meta.wmtsproj.getExtent()) / 256
    meta.wmtsresolutions = []
    meta.wmtsmatrixids = []
    for (let z = 0; z < 19; ++z) {
      meta.wmtsresolutions.push(size / Math.pow(2, z))
      meta.wmtsmatrixids.push(z.toString())
    }
    const basemapgroup = new LayerGroup(), layergroup = new LayerGroup(), svgroup = new LayerGroup(), odgroup = new LayerGroup()
    basemapgroup.set('nm', 'basemapgroup')
    const controls = [new ZoomSlider(), new MousePosition({ projection: 'EPSG:4326', coordinateFormat: createStringXY(4) }), new ScaleLine({
      units: 'metric', bar: true, steps: 5, text: true, minWidth: 150
    })]
    const comctlops = { fontSize: '12px', fontWeight: 'normal', width: '40px', height: '40px', right: '8px' }
    const basemapctrl = new MapControl({ ...comctlops, label: ['배경', '지도'], top: '60px', clickevt: () => pop('bgcard') })
    controls.push(basemapctrl);
    const toolctrl = new MapControl({ ...comctlops, label: ['지도', '도구'], top: '105px', clickevt: () => pop('maptools') })
    controls.push(toolctrl);
    const routectrl = new MapControl({ ...comctlops, label: metaStore.t('route'), top: '150px', clickevt: () => pop('route') })
    controls.push(routectrl);
    const svctrl = new MapControl({ ...comctlops, label: metaStore.t('streetview'), top: '195px', clickevt: () => pop('sv') })
    controls.push(svctrl);
    const setposctrl = new MapControl({ ...comctlops, label: ['좌표로', '이동'], top: '240px', clickevt: () => pop('movepos') })
    controls.push(setposctrl);
    const fullscreenctrl = new MapControl({ ...comctlops, label: ['전체', '화면'], top: '285px', clickevt: () => { screenfull.toggle(qsel('.map_right')) } })
    controls.push(fullscreenctrl);
    const initctrl = new MapControl({
      ...comctlops, label: metaStore.t('initialize'), top: '330px'
      , clickevt: () => { metaStore.dialog({ shown: true, ttl: 'initialize', cont: 'init_con', showcancel: true, istk: true, onok: () => window.location.reload() }) }
    })
    controls.push(initctrl);
    const memolistctrl = new MapControl({ ...comctlops, label: ['나의', '메모'], top: '380px', clickevt: () => pop('memolist') })
    controls.push(memolistctrl);
    const currentposctrl = new MapControl({
      label: '<i class="mdi-target mdi v-icon notranslate v-theme--light v-icon--size-default v-icon--clickable" role="button" aria-hidden="false" tabindex="0"></i>'
      , fontSize: '12px', fontWeight: 'normal', width: '23px', height: '23px', bottom: '270px', right: '8px'
      , clickevt: () => {
        navigator.geolocation.getCurrentPosition(position => meta.map.getView().animate({ center: fromLonLat([position.coords.longitude, position.coords.latitude]), duration: 200 })
          , err => {
            metaStore.toastKey('location.error.unavailable', false)
          })
      }
    })
    controls.push(currentposctrl)
    const measurelayer = new VectorLayer({ source: new VectorSource() })
    measurelayer.set('name', 'measurelayer')
    measurelayer.getSource().on('addfeature', async evt => {
      if (meta.suppressmeasurefeatureadd) return
      let color = 'rgba(255,0,0,1)'
      if (meta.measuretype == 'area') color = 'rgba(0, 255, 0, 1)'
      if (meta.measuretype == 'radius') color = 'rgba(0, 0, 255, 1)'
      if (meta.measuretype == 'slope') color = 'rgba(255, 255, 0, 1)'
      const fill = new Fill({ color: 'rgba(255,255,255,0.5)' })
      const style = new Style({ fill: fill, stroke: new Stroke({ color: color, width: 4 }) })
      evt.feature.setStyle(style)
      if (meta.measuretype == 'distance') {
        const coords = evt.feature.getGeometry().getCoordinates()
        let distinmeter = 0
        meta.suppressmeasurefeatureadd = true
        coords.forEach((curr, i) => {
          const pt = new Feature({ geometry: new Point(curr) })
          const ptstyle = new Style({
            image: new Circle({
              fill: new Fill({ color: 'rgba(0,255,0,0.5)' })
              , stroke: new Stroke({ color: 'rgba(0,255,255,1)', width: 2 }), radius: 5
            })
          })
          pt.setStyle(ptstyle)
          meta.measurelayer.getSource().addFeature(pt)
          if (i === 0) return
          const prev = coords[i - 1]
          distinmeter += mdist(prev, curr)
          const el = document.createElement('div')
          el.className = 'v-card v-theme--light v-card--density-default v-card--variant-elevated'
          el.innerHTML = formDist(distinmeter)
          if (i == coords.length - 1) el.innerHTML = metaStore.t(meta.measuretype) + ':' + el.innerHTML
          const overlay = new Overlay({ positioning: 'bottom-center', offset: [0, -5], element: el, position: curr, autoPan: true })
          meta.map.addOverlay(overlay)
          meta.measureovers.push(overlay)
        })
        setTimeout(() => meta.suppressmeasurefeatureadd = false, 100)
      }
      if (meta.measuretype == 'area') {
        const el = document.createElement('div')
        el.className = 'v-card v-theme--light v-card--density-default v-card--variant-elevated'
        const areainmeter = marea(evt.feature)
        el.innerHTML = metaStore.t(meta.measuretype) + ':' + formArea(areainmeter)
        const cen = evt.feature.getGeometry().getInteriorPoint().getCoordinates()
        const overlay = new Overlay({ positioning: 'top-center', element: el, position: cen })
        meta.map.addOverlay(overlay)
        meta.measureovers.push(overlay)
      }
      if (meta.measuretype == 'radius') {
        const cen = evt.feature.getGeometry().getCenter()
        const pt = new Feature({ geometry: new Point(cen) })
        const ptstyle = new Style({
          image: new Circle({
            fill: new Fill({ color: 'rgba(0,255,0,0.5)' })
            , stroke: new Stroke({ color: 'rgba(0,255,255,1)', width: 2 }), radius: 5
          })
        })
        pt.setStyle(ptstyle)
        meta.suppressmeasurefeatureadd = true
        meta.measurelayer.getSource().addFeature(pt)
        const radius = evt.feature.getGeometry().getRadius()
        const edge = [cen[0] + radius, cen[1]]
        const distinmeter = mdist(cen, edge)
        const areainmeter = Math.PI * Math.pow(distinmeter, 2)
        const el = document.createElement('div')
        el.className = 'v-card v-theme--light v-card--density-default v-card--variant-elevated'
        el.innerHTML = metaStore.t(meta.measuretype) + ':' + formDist(distinmeter)
        el.innerHTML += '<br/>' + metaStore.t('area') + ':' + formArea(areainmeter)
        const overlay = new Overlay({ positioning: 'bottom-center', offset: [0, -5], element: el, position: cen })
        meta.map.addOverlay(overlay)
        meta.measureovers.push(overlay)
        setTimeout(() => meta.suppressmeasurefeatureadd = false, 100)
      }
      if (meta.measuretype == 'slope') {
        const lastsl = meta.measurelayer.getSource().getFeatures().find(fea => fea.get('slopeline'))
        if (lastsl) meta.measurelayer.getSource().removeFeature(lastsl)
        evt.feature.set('slopeline', true)
        metaStore.blockLoading()
        const fea = evt.feature.clone()
        fea.setGeometry(fea.getGeometry().transform(meta.map.getView().getProjection(), 'EPSG:4326'))
        const res = await post('rest/authed/member/slopes', { wkt: new WKT().writeFeature(fea) })
        metaStore.blockLoading(false)
        meta.slopedata = null
        const data = { labels: [], datasets: [{ label: metaStore.t('height'), data: [] }], slopes: res.data }
        res.data.forEach((slope, idx) => {
          data.labels.push(slope.x.toFixed(3) + ',' + slope.y.toFixed(3))
          data.datasets[0].data.push(slope.z)
        })
        meta.slopedata = data
        meta.map.getView().fit(evt.feature.getGeometry().getExtent(), { padding: [150, 150, 400, 150], duration: 100 })
        pop('slope')
      }
    })
    const routelayer = new VectorLayer({ source: new VectorSource() })
    routelayer.set('name', 'routelayer')
    const searchlayer = new VectorLayer({
      source: new VectorSource(), style: fea => {
        return new Style({ image: new Icon({ anchor: [0.5, 46], anchorXUnits: 'fraction', anchorYUnits: 'pixels', src: `${config.frontRoot}marker_${fea.get('selected') ? 'green' : 'blue'}.png` }) })
      }
    })
    searchlayer.set('name', 'searchlayer')
    const picklayer = new VectorLayer({ source: new VectorSource() })
    picklayer.set('name', 'picklayer')
    meta.map = new Map({
      target: 'map', layers: [basemapgroup, layergroup, odgroup, svgroup, routelayer, searchlayer, picklayer, measurelayer]
      , controls: defaultControls().extend(controls), view: new View()
    })
    meta.mapinited = true
    meta.map.getView().setConstrainResolution(true)
    meta.measurelayer = measurelayer
    meta.routelayer = routelayer
    meta.searchlayer = searchlayer
    meta.picklayer = picklayer
    meta.basemapgroup = basemapgroup
    meta.layergroup = layergroup
    meta.svgroup = svgroup
    meta.odgroup = odgroup
    const extent = transformExtent([kext.value.minx, kext.value.miny, kext.value.maxx, kext.value.maxy], 'EPSG:4326', meta.map.getView().getProjection())
    fitToExtent(extent)
    if (meta.initcenpos) meta.map.getView().setCenter(fromLonLat(JSON.parse(`[${meta.initcenpos}]`)))
    if (meta.initzoom) meta.map.getView().setZoom(meta.initzoom)
    meta.map.on('moveend', async evt => {
      if (meta.suppressmoveend) return
      const pos = evt.map.getView().getCenter()
      const addr = await posToAddr(pos)
      meta.selsidocode = -1
      meta.selsggcode = -1
      meta.selumdcode = -1
      if (!addr.response || !addr.response.result) return
      let rslt = addr.response.result
      rslt = rslt[0]
      let sido = rslt.structure.level1, sgg = rslt.structure.level2, umd = rslt.structure.level4L
      sido = meta.sidos.find(item => item.lowestAdmCodeNm == sido)
      if (sido) debounceSelProvince('sidos', sido.admCode, () => {
        sgg = meta.sggs.find(item => item.lowestAdmCodeNm == sgg)
        if (sgg) debounceSelProvince('sggs', sgg.admCode, () => {
          umd = meta.umds.find(item => item.lowestAdmCodeNm == umd)
          if (umd) debounceSelProvince('umds', umd.admCode, () => { })
        })
      })
    })
    meta.map.on('singleclick', async evt => {
      if (meta.measuretype) return
      let serverfeatures = await pickServerFeatures(evt.coordinate)
      let svfeature = serverfeatures ? serverfeatures.find(fea => fea.id.startsWith('sv_')) : null
      if (svfeature) {
        if (svfeature.id.startsWith('sv_line')) {
          const lyrnm = svfeature.id.split('.')[0].replace('_line', '_point')
          const queryxml = `<wfs:GetFeature service="WFS" version="2.0.0"
          xmlns:wfs="http://www.opengis.net/wfs/2.0"
          xmlns:fes="http://www.opengis.net/fes/2.0"
          xmlns:gml="http://www.opengis.net/gml/3.2"
          xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
          outputFormat="application/json"
          xsi:schemaLocation="http://www.opengis.net/wfs/2.0
              http://schemas.opengis.net/wfs/2.0/wfs.xsd">
          <wfs:Query typeNames="${lyrnm}" srsName="EPSG:4326" count="10">
            <fes:Filter>
              <fes:DWithin>
                <fes:ValueReference>the_geom</fes:ValueReference>
                <gml:Point srsName="EPSG:4326">
                  <gml:pos>${lonlat[0]} ${lonlat[1]}</gml:pos>
                </gml:Point>
                <fes:Distance uom="meters">100</fes:Distance>
              </fes:DWithin>
            </fes:Filter>
          </wfs:Query>
        </wfs:GetFeature>`
          let res = await fetch(config.backend + 'wfs', {
            method: 'POST',
            body: queryxml,
            headers: {
              'Content-Type': 'text/xml',
            },
          })
          if (!res.ok) {
            console.log('wfs error')
          }
          res = await res.json()
          if (res.features.length > 0) {
            svfeature = _.minBy(res.features, feature => getDistance(lonlat, feature.geometry.coordinates))
          }
        }
        selSvFeature(svfeature)
        return
      }
      if (meta.seltab == 'places_addr' && meta.searched.ttl) {
        const feature = evt.map.getFeaturesAtPixel(evt.pixel, { layerFilter: layer => layer.get('name') == 'searchlayer', hitTolerance: 10 })[0]
        if (!feature) return selSearched()
        return selSearched(feature.get('id'))
      }
      const lonlat = toLonLat(evt.coordinate, meta.map.getView().getProjection())
      if (meta.seltab == 'layers') {
        if (meta.onrequest) return
        if (!serverfeatures || serverfeatures.length == 0) return
        serverfeatures = _.sortBy(serverfeatures, feature => getDistance(lonlat, toLonLat(feature.geometry.coordinates)))
        popFeatureInfo(serverfeatures[0], evt.coordinate)
      }
    })
    meta.map.getViewport().addEventListener('contextmenu', evt => {
      evt.preventDefault()
    })
  }
async function init() {
  // const chkloginres=await get('rest/public/checkloggedin')
  // if(!chkloginres.isSuccess){
  //   memStore.reset()
  //   metaStore.toastKey('signinisrequired',false)
  //   return router.push('/login')
  // }
  Cookies.remove('admdatamenu')
  const provinces = ['sidos', 'sggs', 'umds']
  provinces.forEach(key => meta[key].push({ admCode: -1, lowestAdmCodeNm: metaStore.t('selection') }))
  screenfull.on('change', () => meta.hideleftbtntgl = screenfull.isFullscreen)
  loadEpsgsWithPrjInit(async epsgs => {
    meta.epsgs = epsgs
    const todyitems = (res, type) => {
      if (!res?.data) return
      const items = res.data[type]
      meta[type] = { togglelayerall: true, layers: [], olayers: [], layerseachcnt: 0, layerttlcnt: 0, selgroupid: 'defaultgroups' }
      meta[type].groups = res.data.groups || []
      meta[type].layers = _.sortBy(items, 'order').map(lyr => {
        if (!lyr.groupid) lyr.groupid = 'defaultgroups'
        lyr.opacity = 100
        if (!lyr.groupid || lyr.groupid === 'defaultgroups') {
          lyr.gorder = -1
        } else {
          const group = meta[type].groups.find(group => group.id === lyr.groupid)
          lyr.gorder = group ? group.gorder : -1
        }
        return lyr
      });
      meta[type].layers = _.orderBy(meta[type].layers, ['gorder', 'order'], ['asc', 'asc'])
      meta[type].layers.forEach(lyr => lyr.shown = true)
      meta[type].olayers = _.clone(meta[type].layers)
      meta[type].layerseachcnt = meta[type].layers.length
      meta[type].layerttlcnt = meta[type].layers.length
      if (meta[type].layers.some(lyr => lyr.groupid === 'defaultgroups')) {
        meta[type].groups.unshift({ id: 'defaultgroups', nm: metaStore.t('defaultgroups') });
      }
      meta[type].layermodels = {}
      meta[type].groups.forEach(group => meta[type].layermodels[group.id] = meta[type].layers.filter(lyr => lyr.groupid === group.id).map(lyr => lyr.id))
    }
    gets({
      urls: ['rest/authed/member/odsandgroups', 'rest/authed/member/layersandgroups'], pmss: [{ type: 'ods' }, { type: 'layers' }], callback: resarr => {
        if (resarr.some(res => res == null)) {
          return;
        }
        resarr.forEach(res => todyitems(res, res.pms.type))
        get('rest/authed/member/confswkeyin/initmapzoom,initmapcenpos,vwdomain,vwapikey', res => {
          meta.initzoom = res.data.find(conf => conf.wkey == 'initmapzoom')?.dval || null
          meta.initcenpos = res.data.find(conf => conf.wkey == 'initmapcenpos')?.sval || null
          meta.vwdomain = res.data.find(conf => conf.wkey == 'vwdomain')?.sval || null
          meta.vwapikey = res.data.find(conf => conf.wkey == 'vwapikey')?.sval || null
          if (!meta.vwapikey) metaStore.toast('브이월드 키가 없습니다.')
          korProvinces('sidos')
          initMap()
          fetch(config.backend + 'wms?REQUEST=GetCapabilities').then(response => response.text()).then(async wmsxmlstr => {
            const dparser = new DOMParser()
            const xmlDoc = dparser.parseFromString(wmsxmlstr, 'application/xml')
            meta.bboxes = {}
            xmlDoc.documentElement.querySelector('Layer').querySelectorAll('Layer').forEach(lyrcapa => {
              const ttl = lyrcapa.querySelector('Title').textContent
              if (!meta.gslyrnms) meta.gslyrnms = []
              meta.gslyrnms.push(ttl)
              if (!ttl.startsWith('layer_') && !ttl.startsWith('sv_point') && !ttl.startsWith('od_')) return
              let bbox = lyrcapa.querySelector('BoundingBox')
              let crs = bbox.getAttribute('CRS')
              const minx = bbox.getAttribute('minx')
              const miny = bbox.getAttribute('miny')
              const maxx = bbox.getAttribute('maxx')
              const maxy = bbox.getAttribute('maxy')
              if (crs.includes(':84') || crs.includes('4326')) bbox = senitizeLonLatBbox(minx, miny, maxx, maxy)
              else bbox = [minx, miny, maxx, maxy]
              if (bbox.some(a => a == '-1.0E-4')) return
              bbox = transformExtent(bbox, crs, meta.map.getView().getProjection())
              meta.bboxes[ttl] = bbox
            })
            fetch(config.backend + 'wmts?REQUEST=GetCapabilities').then(response => response.text()).then(async wmtsxmlstr => {
              meta.wmtscapa = new WMTSCapabilities().read(wmtsxmlstr)
              meta.ltreetypes.forEach(type => {
                _.orderBy(meta[type].layers, ['gorder', 'order'], ['desc', 'desc']).forEach(lyr => addLayer(type, lyr))
              })
              await initSvs()
              //search(1,true)
              // delete meta.wmtscapa
            })
          })
        })
      }
    })
  })
}
onMounted(() => {
  init()
})
</script>
<template>
  <MenuLayout>
    <div class="maproot">
      <div v-if="meta.showleft" class="map_left">
        <v-card elevation="2">
          <v-tabs fixed-tabs :items="meta.tabs" v-model="meta.seltab"
            @update:model-value="search(1, true); filterLayer(true);">
            <v-tab value="layers">{{ $t('layers') }}</v-tab>
            <v-tab value="places_addr">{{ $t('places_addr') }}</v-tab>
          </v-tabs>
          <div style="margin: 5px;">
            <v-alert>
              <v-row no-gutters>
                <v-col class="me-1"><v-text-field hide-details variant="outlined" density="compact"
                    :placeholder="$t('enteryoursearchterm')" v-model="meta.searchval"
                    @update:model-value="meta.seltab == 'layers' ? filterLayer() : () => { }"
                    @keyup.enter="meta.seltab == 'layers' ? filterLayer() : search(1)" /></v-col>
                <v-col cols="4" class="text-right">
                  <v-btn prepend-icon="mdi-magnify" color="secondary" class="me-2" size="40"
                    @click="meta.seltab == 'layers' ? filterLayer() : search(1)" />
                  <v-btn color="error" prepend-icon="mdi-close" size="40"
                    @click="meta.seltab == 'layers' ? filterLayer(true) : search(1, true)" />
                </v-col>
              </v-row>
            </v-alert>
            <div class="listwrap">
              <v-tabs-window v-model="meta.seltab">
                <v-tabs-window-item v-for="tab in meta.tabs" :key="tab" :value="tab">
                  <div v-if="tab == 'layers'" v-for="type in meta.ltreetypes" :key="type">
                    <v-row>
                      <v-col align-self="center" class="ps-5">{{ $t(type == 'ods' ? 'objectdetection' : 'layers') }}({{
                        commaFormat(meta[type].layerseachcnt) }}/{{ commaFormat(meta[type].layerttlcnt) }})</v-col>
                      <v-col cols="3"><v-switch hide-details color="primary" v-model="meta[type].togglelayerall"
                          @update:model-value="val => tglLayer(type, 'all', val)" /></v-col>
                    </v-row>
                    <div class="layerwrap pa-2">
                      <v-expansion-panels v-if="meta[type].groups.length" variant="accordion"
                        v-model="meta[type].selgroupid">
                        <v-expansion-panel v-for="group in meta[type].groups" :value="group.id">
                          <v-expansion-panel-title>
                            <div style="max-width: 248px;">{{ group.nm }}</div>
                          </v-expansion-panel-title>
                          <v-expansion-panel-text>
                            <v-expansion-panels multiple hide-actions :model-value="meta[type].layermodels[group.id]">
                              <v-expansion-panel v-for="layer in meta[type].layers.filter(lyr => lyr.groupid == group.id)"
                                :value="layer.id">
                                <v-row no-gutters class="ms-5 me-5">
                                  <v-col align-self="center">
                                    <v-icon v-if="layer.layerkind == 'raster'" icon="mdi-image-area" />
                                    <v-icon v-else-if="layer.layerkind == 'api'" icon="mdi-api" />
                                    <v-icon v-else-if="layer.layerkind == 'vector' && layer.layertype.includes('Point')"
                                      icon="mdi-vector-point" />
                                    <v-icon v-else-if="layer.layerkind == 'vector' && layer.layertype.includes('Line')"
                                      icon="mdi-vector-line" />
                                    <v-icon v-else-if="layer.layerkind == 'vector' && layer.layertype.includes('Polygon')"
                                      icon="mdi-vector-polygon" />
                                    <span class="cursor-pointer" @click="focusLayer(layer.gslayernm)">{{ layer.nm
                                      }}</span>
                                  </v-col>
                                  <v-col cols="1"><v-switch hide-details color="primary" density="compact"
                                      v-model="layer.shown"
                                      @update:model-value="val => tglLayer(type, layer.id, val)" /></v-col>
                                </v-row>
                                <v-divider />
                                <v-row no-gutters class="ms-3 me-3 mt-3">
                                  <v-col><v-btn block :text="$t('metadata')"
                                      @click="pop('metadata', layer.id)" /></v-col>
                                  <v-col v-if="layer.layerkind == 'vector'" class="ps-1"><v-btn block
                                      :text="$t('viewdatadetails')" @click="pop('viewdatadetails', layer.id)" /></v-col>
                                </v-row>
                                <v-row no-gutters class="ms-5 me-5 mt-3">
                                  <v-col><v-slider color="secondary" min="0" max="100" step="1" v-model="layer.opacity"
                                      @update:model-value="val => opaqueLayer(type, layer.id, val)" /></v-col>
                                  <v-col cols="3">
                                    <p class="text-center mt-1">{{ layer.opacity }}%</p>
                                  </v-col>
                                </v-row>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </div>
                  <p v-if="tab == 'places_addr' && !meta.searched.ttl" class="text-center pa-3">
                    {{ $t('noresultsfound') }}
                  </p>
                  <div v-if="tab == 'places_addr' && meta.searched.ttl">
                    <v-tabs fixed-tabs v-model="meta.selsearchtab" :items="meta.searchtabs"
                      @update:model-value="search(1)">
                      <v-tab v-for="searchtab in meta.searchtabs" :value="searchtab">{{ $t(searchtab) }}</v-tab>
                    </v-tabs>
                    <v-tabs-window v-model="meta.selsearchtab">
                      <v-tabs-window-item v-for="searchtab in meta.searchtabs" :key="searchtab" :value="searchtab"
                        class="pa-1">
                        <p v-if="!meta.searched.ttl" class="text-center ma-2">{{ $t('noresultsfound') }}</p>
                        <div style="height: calc(100vh - 192px);overflow-y: auto;">
                          <div v-if="searchtab == 'all' || searchtab == 'places'">
                            <p>{{ $t('places') + `
                              (${commaFormat(meta.searched.places.dpcnt || 0)}/${commaFormat(meta.searched.places.ttl||0)})`
                              }}</p>
                            <v-divider />
                            <div v-if="meta.searched.places.items.length">
                              <div :class="searchtab == 'places' ? 'searchlistwrap' : ''">
                                <v-card v-for="place in meta.searched.places.items" variant="outlined" class="ma-2"
                                  :title="place.title">
                                  <v-card-text class="pe-0">
                                    <p>{{ place.address.road }}</p>
                                    <p>{{ place.address.parcel }}</p>
                                  </v-card-text>
                                  <v-row class="pa-1">
                                    <!-- <v-col><v-btn density="compact" :text="$t('favorites')"/></v-col> -->
                                    <v-col class="text-right">
                                      <v-btn append-icon="mdi-chevron-right" density="compact" :text="$t('viewdetails')"
                                        @click="selSearched(place.id)" />
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </div>
                              <v-btn v-if="searchtab == 'all'" block color="secondary" class="mt-3 mb-3"
                                prepend-icon="mdi-plus" :text="$t('more')"
                                @click="meta.selsearchtab = 'places'; search(1)" />
                              <v-pagination v-else density="compact" class="ma-auto"
                                :length="meta.searched.places.pagettl" :total-visible="5"
                                :model-value="meta.searched.places.currpage" @update:model-value="search" />
                            </div>
                          </div>
                          <div v-if="searchtab == 'all' || searchtab == 'addr'">
                            <p>{{ $t('addr') + `
                              (${commaFormat(meta.searched.addrs.dpcnt || 0)}/${commaFormat(meta.searched.addrs.ttl||0)})`
                              }}</p>
                            <v-divider />
                            <div v-if="meta.searched.addrs.items.length">
                              <div :class="searchtab == 'addr' ? 'searchlistwrap' : ''">
                                <v-card v-for="addr in meta.searched.addrs.items" variant="outlined" class="ma-2">
                                  <v-card-text>
                                    <p>{{ addr.address.road }}</p>
                                    <p>{{ addr.address.parcel }}</p>
                                  </v-card-text>
                                  <v-row class="pa-1">
                                    <!-- <v-col><v-btn density="compact" :text="$t('favorites')"/></v-col> -->
                                    <v-col class="text-right"><v-btn append-icon="mdi-chevron-right" density="compact"
                                        :text="$t('viewdetails')" @click="selSearched(addr.id)" /></v-col>
                                  </v-row>
                                </v-card>
                              </div>
                              <v-btn v-if="searchtab == 'all'" block color="secondary" class="mt-3"
                                prepend-icon="mdi-plus" :text="$t('more')"
                                @click="meta.selsearchtab = 'addr'; search(1)" />
                              <v-pagination v-else density="compact" class="ma-auto"
                                :length="meta.searched.addrs.pagettl" :total-visible="5"
                                :model-value="meta.searched.addrs.currpage" @update:model-value="search" />
                            </div>
                          </div>
                        </div>
                      </v-tabs-window-item>
                    </v-tabs-window>
                  </div>
                </v-tabs-window-item>
              </v-tabs-window>
            </div>
          </div>
        </v-card>
      </div>
      <div class="map_right">
        <div id="map"></div>
        <div style="position: absolute;bottom: 0;right: 200px;font-size: 12px;color: red;">제공된 모든 자료는 법적 효력이 없으며 참고용
          자료입니다</div>
        <!-- <v-icon v-if="!meta.hideleftbtntgl" :icon="'mdi-chevron-'+(meta.showleft?'left':'right')" class="left_tglbtn" @click="meta.showleft=!meta.showleft"/> -->
        <img class="left_tglbtn" :src="config.frontRoot + 'img/etc/lnb_handle_normal.png'"
          @click="meta.showleft = !meta.showleft"
          onmouseover="this.src=this.src.includes('_normal')?this.src.replace('_normal','_hover'):this.src.replace('_hover','_normal')"
          onmouseout="this.src=this.src.includes('_hover')?this.src.replace('_hover','_normal'):this.src.replace('_normal','_hover')" />
        <BgMapSelector v-if="meta.mapinited" v-show="meta.poptype == 'bgcard'" :map="meta.map" :onClose="pop"
          :onLoad="() => meta.poptype = null" :onUpdate="bid => meta.selbgmapid = bid" />
        <v-card class="provinceselector position-absolute">
          <v-defaults-provider
            :defaults="{ VSelect: { hideDetails: true, variant: 'outlined', density: 'compact', noGutters: true, rounded: 0 } }">
            <v-row no-gutters>
              <v-col>
                <select class="sidos" @change="val => selProvince('sidos', val.target.value)">
                  <option v-for="sido in meta.sidos" :value="sido.admCode" :selected="sido.admCode == meta.selsidocode">{{
                    sido.lowestAdmCodeNm }}</option>
                </select>
              </v-col>
              <v-col>
                <select class="sggs" @change="val => selProvince('sggs', val.target.value)">
                  <option v-for="sgg in meta.sggs" :value="sgg.admCode" :selected="sgg.admCode == meta.selsggcode">{{
                    sgg.lowestAdmCodeNm }}</option>
                </select>
              </v-col>
              <v-col>
                <select class="umds" @change="val => selProvince('umds', val.target.value)">
                  <option v-for="umd in meta.umds" :value="umd.admCode" :selected="umd.admCode == meta.selumdcode">{{
                    umd.lowestAdmCodeNm }}</option>
                </select>
              </v-col>
            </v-row>
          </v-defaults-provider>
        </v-card>
        <v-card v-if="meta.poptype == 'movepos'" class="moveposcard position-absolute" width="320">
          <v-card-title>
            <v-row>
              <v-col>{{ $t('gotocoordinates') }}</v-col>
              <v-col cols="3" class="text-right"><v-btn variant="flat" density="compact" icon="mdi-close"
                  @click="pop()" /></v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-select hide-details variant="outlined" density="compact" :label="$t('coordinatesystem')"
              :items="meta.epsgs.map(epsg => ({ title: 'EPSG:' + epsg, value: epsg }))" v-model="meta.selmoveposepsg" />
            <v-row no-gutters class="mt-2">
              <v-col class="me-1"><v-text-field hide-details variant="outlined" density="compact"
                  :label="$t('xcoordinate')" v-model="meta.movepos.x" /></v-col>
              <v-col><v-text-field hide-details variant="outlined" density="compact" :label="$t('ycoordinate')"
                  v-model="meta.movepos.y" /></v-col>
            </v-row>
            <v-btn block class="mt-2" color="info" :text="$t('move')"
              @click="setCen(meta.selmoveposepsg, [meta.movepos.x, meta.movepos.y])" />
          </v-card-text>
        </v-card>
        <v-card v-if="meta.poptype == 'maptools'" class="toolscard position-absolute" width="320">
          <v-card-title>
            <v-row>
              <v-col>{{ $t('maptools') }}</v-col>
              <v-col cols="3" class="text-right"><v-btn variant="flat" density="compact" icon="mdi-close"
                  @click="pop(); tglMeasure()" /></v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <p class="ma-2">{{ $t('measurement') }}</p>
            <v-row class="ma-1">
              <v-col class="text-center"><v-btn icon="mdi-ruler" size="small"
                  :color="meta.measuretype == 'distance' ? 'success' : ''" @click="tglMeasure('distance')" />
                <p class="mt-1">{{ $t('distance') }}</p>
              </v-col>
              <v-col class="text-center"><v-btn icon="mdi-texture-box" size="small"
                  :color="meta.measuretype == 'area' ? 'success' : ''" @click="tglMeasure('area')" />
                <p class="mt-1">{{ $t('area') }}</p>
              </v-col>
              <v-col class="text-center"><v-btn icon="mdi-circle-double" size="small"
                  :color="meta.measuretype == 'radius' ? 'success' : ''" @click="tglMeasure('radius')" />
                <p class="mt-1">{{ $t('radius') }}</p>
              </v-col>
              <v-col class="text-center"><v-btn icon="mdi-chart-line" size="small"
                  :color="meta.measuretype == 'slope' ? 'success' : ''" @click="tglMeasure('slope')" />
                <p class="mt-1">{{ $t('slope') }}</p>
              </v-col>
            </v-row>
            <v-btn block class="mt-2" color="error" :text="$t('initialize')" @click="clearMeasure" />
          </v-card-text>
        </v-card>
        <v-card v-if="meta.poptype == 'route'" class="routecard position-absolute" width="350">
          <v-card-title>
            <v-row>
              <v-col>{{ $t('route') }}</v-col>
              <v-col cols="3" class="text-right"><v-btn variant="flat" density="compact" icon="mdi-close"
                  @click="pop(); tglMeasure()" /></v-col>
            </v-row>
          </v-card-title>
          <v-tabs fixed-tabs v-model="meta.selroutetype">
            <v-tab value="car">{{ $t('car') }}</v-tab>
            <v-tab value="foot">{{ $t('walking') }}</v-tab>
          </v-tabs>
          <v-card-text>
            <v-row>
              <v-col><v-combobox no-filter hide-details variant="outlined" density="compact" :label="$t('departure')"
                  :items="meta.selroute.departsearched" item-title="ttl" item-value="id"
                  v-model="meta.selroute.querydepart"
                  @update:model-value="debounceRoutePtSearch('departure')" /></v-col>
              <v-col cols="3"><v-btn size="40" prepend-icon="mdi-plus"
                  @click="meta.selroute.querysos.push(null); meta.selroute.stopoversearched.push([])" /></v-col>
            </v-row>
            <v-row v-for="(stopover, idx) in meta.selroute.querysos">
              <v-col><v-combobox no-filter hide-details variant="outlined" density="compact"
                  :label="`${$t('stopover')}(${idx + 1})`" :items="meta.selroute.stopoversearched[idx]" item-title="ttl"
                  item-value="id" v-model="meta.selroute.querysos[idx]"
                  @update:model-value="debounceRoutePtSearch('stopover', idx)" /></v-col>
              <v-col cols="3"><v-btn size="40" prepend-icon="mdi-minus"
                  @click="meta.selroute.querysos.splice(idx, 1); meta.selroute.stopoversearched.splice(idx, 1)" /></v-col>
            </v-row>
            <v-row>
              <v-col><v-combobox no-filter hide-details variant="outlined" density="compact" :label="$t('destination')"
                  :items="meta.selroute.destsearched" item-title="ttl" item-value="id" v-model="meta.selroute.querydest"
                  @update:model-value="debounceRoutePtSearch('destination')" /></v-col>
            </v-row>
            <v-btn class="mt-2 mb-2" block color="info" :text="$t('route')" :disabled="!meta.selroute.ready"
              @click="actRoute" />
            <v-expansion-panels v-if="meta.selroute.rslt" variant="accordion" v-model="meta.selroute.rslt.selidx"
              @update:model-value="drawRoute">
              <v-expansion-panel v-for="(path, idx) in meta.selroute.rslt?.paths" variant="accordion"
                :title="`${(meta.selroute.rslt.dists[idx] / 1000).toFixed(3)}km`" :value="idx">
                <v-expansion-panel-text>
                  <div style="max-height: 300px;overflow-y: auto;">
                    <ul>
                      <li v-for="(ins, iidx) in path.instructions">{{
                        `${iidx + 1}.${ins.text}(${(ins.distance / 1000).toFixed(3)}km)` }}</li>
                    </ul>
                  </div>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
        <v-card :class="'svcard position-absolute' + (meta.poptype == 'sv' ? ' d-print-block' : ' d-none')">
          <v-card-title>
            <v-row>
              <v-col>{{ $t('streetview_list') }}</v-col>
              <v-col cols="3" class="text-right"><v-btn variant="flat" density="compact" icon="mdi-close"
                  @click="pop(); tglMeasure()" /></v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <Vue3TreeVue ref="svtreeref" class="svtree" :items="meta.svtree" isCheckable @onCheck="checkSvTree">
              <template #item-prepend-icon="treeViewItem">
                <input class="itemval" type="hidden"
                  :value="JSON.stringify({ id: treeViewItem.id, isgroup: treeViewItem.isgroup })" />
                <v-icon v-if="treeViewItem.isgroup" icon="mdi-layers-outline" />
                <v-icon v-else-if="treeViewItem.layertype.includes('Point')" icon="mdi-vector-point" />
                <v-icon v-else-if="treeViewItem.layertype.includes('Line')" icon="mdi-vector-line" />
                <v-icon v-else-if="treeViewItem.layertype.includes('NodeLink')" icon="mdi-link" />
              </template>
            </Vue3TreeVue>
          </v-card-text>
        </v-card>
        <v-card
          v-if="meta.poptype == 'slope' || meta.poptype == 'metadata' || meta.poptype == 'viewdatadetails' || meta.poptype == 'memolist'"
          class="pop_bottom">
          <v-card-title>
            <v-row>
              <v-col>{{ meta.popttl }}</v-col>
              <v-col cols="3" class="text-right"><v-btn variant="flat" density="compact" icon="mdi-close"
                  @click="pop()" /></v-col>
            </v-row>
          </v-card-title>
          <v-card-text style="height: calc(100% - 40px);">
            <div v-if="meta.poptype == 'metadata'">
              <v-defaults-provider
                :defaults="{
                  VTextField: { variant: 'outlined', density: 'compact', hideDetails: true, placeholder: $t('enteradescriptionupto500characters') }
                  , VTextarea: { variant: 'outlined', density: 'compact', hideDetails: true, placeholder: $t('enteradescriptionupto500characters') }
                }">
                <v-table class="editmetatbl">
                  <tbody>
                    <tr>
                      <th>{{ $t('metanm') }}</th>
                      <td colspan="3">{{ meta.sellayer.metanm }}</td>
                    </tr>
                    <tr>
                      <th>{{ $t('metatype') }}</th>
                      <td>{{ meta.sellayer.metatype }}</td>
                      <th>{{ $t('metaformat') }}</th>
                      <td style="width: 40%;">{{ meta.sellayer.metaformat }}</td>
                    </tr>
                    <tr>
                      <th>{{ $t('metacrs') }}</th>
                      <td>{{ meta.sellayer.metacrs }}</td>
                      <th>{{ $t('metamodinterval') }}</th>
                      <td>{{ meta.sellayer.metamodinterval }}</td>
                    </tr>
                    <tr>
                      <th>{{ $t('metaarea') }}</th>
                      <td colspan="3">{{ meta.sellayer.metaarea }}</td>
                    </tr>
                    <tr>
                      <th>{{ $t('metaorg') }}</th>
                      <td colspan="3">{{ meta.sellayer.metaorg }}</td>
                    </tr>
                    <tr>
                      <th>{{ $t('metamethod') }}</th>
                      <td colspan="3">{{ meta.sellayer.metamethod }}</td>
                    </tr>
                    <tr>
                      <th>{{ $t('memo') }}</th>
                      <td colspan="3">{{ meta.sellayer.metamemo }}</td>
                    </tr>
                  </tbody>
                </v-table>
              </v-defaults-provider>
            </div>
            <DataDetail v-if="meta.poptype == 'viewdatadetails'" :id="meta.sellayer.id" type="layer" tblheight="220" />
            <div v-if="meta.poptype == 'memolist' && meta.memos">
              <v-row>
                <v-col><v-text-field hide-details variant="outlined" density="compact"
                    :label="$t('enteryoursearchterm')" v-model="meta.memosearchval" /></v-col>
                <v-col><v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')"
                    @click="searchMemo()" /></v-col>
              </v-row>
              <v-table fixed-header class="border-thin mt-2" height="320">
                <thead>
                  <tr>
                    <th>{{ $t('registrationmodificationdate') }}</th>
                    <th>{{ $t('title') }}</th>
                    <th>{{ $t('xcoordinate') }}</th>
                    <th>{{ $t('ycoordinate') }}</th>
                    <th class="text-center">{{ $t('viewroadview') }}</th>
                    <th class="text-center">{{ $t('more') }}</th>
                    <th class="text-center">{{ $t('delete') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="memo in meta.memos">
                    <td>{{ ymd(memo.mdt) }}</td>
                    <td>{{ memo.ttl }}</td>
                    <td>{{ memo.xpos }}</td>
                    <td>{{ memo.ypos }}</td>
                    <td class="text-center"><v-btn density="compact" :text="$t('viewroadview')"
                        @click="openWin(config.frontRoot + 'member/svnew/' + memo.svid + '/' + memo.featureid + '/' + meta.selbgmapid)" />
                    </td>
                    <td class="text-center"><v-btn :text="$t('more')" @click="memoDetailPop(memo.id)" /></td>
                    <td class="text-center"><v-btn color="error" :text="$t('delete')"
                        @click="metaStore.dialog({ shown: true, ttl: 'notelist', cont: 'del_con', showcancel: true, istk: true, onok: () => delMemo(memo.id) })" />
                    </td>
                  </tr>
                </tbody>
              </v-table>
              <v-pagination density="compact" class="ma-auto" :length="meta.memos.pagettl" :total-visible="5"
                :model-value="meta.memos.currpage" @update:model-value="searchMemo" />
            </div>
            <Line class="w-100 h-100" v-if="meta.slopedata" :data="meta.slopedata"
              :options="{ responsive: true, maintainAspectRatio: false, onHover: slopeHover }" />
          </v-card-text>
        </v-card>
      </div>
    </div>
  </MenuLayout>
  <div class="d-none">
    <v-card class="mapdetailpop">
      <v-card-title>
        <v-row>
          <v-col>{{ meta.popinfokind }} {{ $t('details') }}</v-col>
          <v-col cols="3" class="text-right"><v-btn class="mapdetailpop_close" variant="flat" density="compact"
              icon="mdi-close" /></v-col>
        </v-row>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <div class="popcont"></div>
      </v-card-text>
    </v-card>
  </div>
  <Teleport v-if="meta.selmemo" to="#popbody">
    <v-card flat width="400">
      <v-card-title>
        <v-row>
          <v-col>{{ $t('mynotes') }}</v-col>
          <v-col cols="3" class="text-right"><v-btn variant="flat" density="compact" icon="mdi-close"
              @click="memoDetailPop()" /></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-text-field variant="outlined" density="compact" :label="$t('title')"
          :placeholder="$t('enteratitleupto50characters')" :rules="[validators.required]" v-model="meta.selmemo.ttl" />
        <v-textarea variant="outlined" density="compact" :label="$t('contents')"
          :placeholder="$t('enteryourcontentupto500')" :rules="[validators.required]" v-model="meta.selmemo.cont" />
        <p>{{ $t('coordinates') }}</p>
        <v-row class="mb-2">
          <v-col><v-text-field hide-details variant="outlined" density="compact" readonly
              v-model="meta.selmemo.xpos" /></v-col>
          <v-col><v-text-field hide-details variant="outlined" density="compact" readonly
              v-model="meta.selmemo.ypos" /></v-col>
        </v-row>
        <v-text-field class="mb-2" hide-details variant="outlined" density="compact" readonly
          :label="$t('addressinformation')" v-model="meta.selmemo.addr" />
        <img class="d-none memoimg" style="max-width: 100%;max-height: 300px;" />
        <v-file-input show-size hide-details variant="outlined" density="compact" v-model="meta.selmemo.file"
          @update:model-value="memoImgChanged" />
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col><v-btn block variant="elevated" :text="$t('cancel')" @click="memoDetailPop()" /></v-col>
          <v-col><v-btn block variant="elevated" color="primary" :text="$t('save')" @click="saveMemo()"
              :disabled="_.isEmpty(meta.selmemo.ttl) || _.isEmpty(meta.selmemo.cont)" /></v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </Teleport>
</template>
<style>
#map {
  width: 100%;
  height: 100%;
}

.maproot {
  display: flex;
  flex-wrap: nowrap;
  height: 100%;
}

.maproot .map_left {
  width: 350px;
  background-color: #eee;
  height: 100vh;
}

.maproot .map_left>.v-card {
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  margin: 3px 0 0 2px;
}

.maproot .map_right {
  flex-grow: 1;
  position: relative;
}

.maproot input {
  background-color: #fff;
}

.maproot .listwrap {
  height: calc(100vh - 135px);
  overflow-y: auto;
}

.maproot .bgcard {
  position: absolute;
  top: 60px;
  right: 60px;
}

.maproot .left_tglbtn {
  cursor: pointer;
  position: absolute;
  color: #fff;
  width: 24px;
  height: 236px;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 9;
}

.maproot .ol-zoom,
.ol-zoomslider {
  left: auto !important;
  top: auto !important;
  right: 8px;
  bottom: 20px;
}

.maproot .ol-zoomslider {
  bottom: 42px !important;
}

.maproot .ol-zoom {
  height: 246px;
}

.maproot .ol-zoom-out {
  margin-top: 200px !important;
}

.maproot .provinceselector {
  top: 10px;
  right: 10px;
}

.maproot .moveposcard {
  top: 195px;
  right: 55px;
}

.maproot .toolscard {
  top: 105px;
  right: 55px;
}

.maproot .routecard {
  top: 150px;
  right: 55px;
}

.maproot .svcard {
  top: 195px;
  right: 55px;
  width: 350px;
  max-height: 700px;
  overflow-y: auto;
}

.maproot .pop_bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 1px;
  z-index: 9;
  height: 460px;
}

.searchlistwrap {
  height: calc(100vh - 270px);
  overflow-y: auto;
}

.maproot .ol-mouse-position {
  color: #fff;
}

.sidos,
.sggs,
.umds {
  margin: 10px;
  width: 140px;
}

.svtree .tree-item__checkbox-area>label {
  width: 240px;
}
</style>
